import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const CardPreview = ({ card }) => {
  if (!card) return null;

  // mask card number (randomized demo)
  const maskedNumber = "**** **** **** " + (Math.floor(Math.random() * 9000) + 1000);

  return (
    <Paper
      elevation={6}
      sx={{
        width: 340,
        height: 200,
        borderRadius: 4,
        p: 3,
        background: "linear-gradient(135deg, #0ea5e9, #2F80ED)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Top row */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="caption">{card.card_level?.toUpperCase()}</Typography>
        {card.card_brand && (
          <img
            src={
              card.card_brand === "visa"
                ? "https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png"
                : card.card_brand === "mastercard"
                ? "https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                : "https://upload.wikimedia.org/wikipedia/commons/3/30/American_Express_logo.svg"
            }
            alt={card.card_brand}
            width={50}
          />
        )}
      </Box>

      {/* Card number */}
      <Typography variant="h6" letterSpacing={2} fontWeight="bold">
        {maskedNumber}
      </Typography>

      {/* Bottom row */}
      <Box display="flex" justifyContent="space-between">
        <Box>
          <Typography variant="body2">Cardholder</Typography>
          <Typography variant="subtitle2" fontWeight={600}>
            {card.name_on_card}
          </Typography>
        </Box>
        <Box textAlign="right">
          <Typography variant="body2">Expires</Typography>
          <Typography variant="subtitle2">
            {`${new Date().getMonth() + 1}/${new Date().getFullYear() + 3}`}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default CardPreview;